// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1521":"456118d7430515bb","1806":"4b4de4079e4a285a","3449":"ce672e21689fbd78","4138":"defb0e7abdc30846","5763":"1fc2f739132470bb","8045":"36187914fb352575"}[chunkId] + ".css";
};